import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { profile } from '../../data/profile';

export default function Footer() {
    return (
        <Box component="footer" sx={{ bgcolor: '#0b1220', color: 'rgba(255,255,255,0.7)', py: 4 }}>
            <Container maxWidth="lg">
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="space-between">
                    <Typography variant="body2">
                        © {new Date().getFullYear()} {profile.name} · Hecho con Django, React y Docker
                    </Typography>
                    <Link component={RouterLink} to="/login" variant="body2" underline="hover" sx={{ color: 'rgba(255,255,255,0.5)' }}>
                        Área privada
                    </Link>
                </Stack>
            </Container>
        </Box>
    );
}
